<template>
	<div class="componyBanner">
		<div class="componyBanner-top">
			<el-input v-model="keyword" placeholder="请输入关键字" @input="keywordChage"></el-input>
			<el-select v-model="category_id" placeholder="请选择" @change="categoryChange">
				<el-option v-for="item in recruitmentOptions" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-button type="primary" icon="el-icon-edit" @click="caseAddMain">添加</el-button>
			<el-button type="primary" icon="el-icon-edit" @click="caseEditMain">编辑</el-button>
			<el-button type="primary" icon="el-icon-delete" @click="caseDeleteMain">删除</el-button>
		</div>
		<div class="componyBanner-bottom">
			<div class="componyBanner-bottom-table" v-loading="loading">
				<el-table ref="multipleTable" :data="tableData" border style="width: 100%" :height="height"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55" align="center">
					</el-table-column>

					<el-table-column prop="name" label="招聘职位" align="center">
					</el-table-column>

					<el-table-column prop="department" label="所属部门" align="center">
					</el-table-column>
					<el-table-column prop="is_show" label="是否显示" align="center">
						<template slot-scope="scope">
							<p>{{scope.row.is_show?'是':'否'}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="rank" label="排序id" align="center">
					</el-table-column>
					<el-table-column prop="resumes_num" label="简历数" align="center">
					</el-table-column>
					<el-table-column prop="page_view" label="浏览量" align="center">
					</el-table-column>
					<el-table-column prop="create_time" label="创建时间" align="center">
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="100">
						<template slot-scope="scope">
							<el-button style="background: #1EB96B;color: white;" type="success">简历</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="componyBanner-bottom-page">
				<div class="componyBanner-bottom-page-left">
					总共 {{product_row_count}} 条 当前第 {{product_page}} 页 共 {{product_page_count}} 页
				</div>
				<div class="componyBanner-bottom-page-right">
					<el-pagination background layout="prev, pager, next,sizes" @size-change="handleSizeChange"
						:page-size="pageSize" :page-sizes="[10, 15, 20, 25,50,100]" @prev-click="physicianPrevMain"
						@next-click="physicianNextMain" @current-change="physicianCurrentMain"
						:total="product_row_count" :current-page="product_page">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 添加 -->
		<el-dialog title="添加问题" :visible.sync="dialogVisibleAdd" width="50%">
			<div class="componyBannerAdd-center">
				<el-form ref="recruitAddForm" v-model="recruitAddForm" label-width="120px" :rules="recruitAddFormRules">
					<el-form-item label="职位名称" prop="name">
						<el-input v-model="recruitAddForm.name" :rows="5" style="max-width: 300px"></el-input>
					</el-form-item>
					<el-form-item label="所属分类" prop="category_id">
						<el-select v-model="recruitAddForm.category_id" placeholder="请选择部门">
							<el-option v-for="item in categoryAddOptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="所属城市" prop="workplace">
						<el-cascader v-model="recruitAddForm.workplace" :props="{ multiple: true}"
							:options="cityOptions" @change="handleChange">
						</el-cascader>
					</el-form-item>
					<el-form-item label="所属部门" prop="department_id">
						<el-select v-model="recruitAddForm.department_id" placeholder="请选择部门">
							<el-option v-for="item in recruitmentAddOptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="招聘人数" prop="recruit_num">
						<el-input type="number" :min="1" v-model="recruitAddForm.recruit_num"></el-input>
					</el-form-item>

					<el-form-item label="招聘详情" prop="image">
						<quill-editor class="ql-editor question-ql-editor" v-model="recruitAddForm.demand"
							:options="editorOption">
						</quill-editor>
					</el-form-item>
					<el-form-item label="排序ID" prop="rank">
						<el-input type="number" :min="1" v-model="recruitAddForm.rank"></el-input>
					</el-form-item>
					<el-form-item label="虚拟浏览量" prop="page_view">
						<el-input type="number" :min="1" v-model="recruitAddForm.page_view"></el-input>
					</el-form-item>
					<el-form-item label="邮箱地址" prop="email">
						<el-input type="text" v-model="recruitAddForm.email"></el-input>
					</el-form-item>
					<el-form-item label="是否开启投递" prop="is_deliver">
						<el-switch v-model="recruitAddForm.is_deliver" active-color="#13ce66">
						</el-switch>
					</el-form-item>
					<el-form-item label="添加日期" prop="create_time">
						<el-date-picker v-model="recruitAddForm.create_time" type="datetime" placeholder="选择日期时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="招聘状态" prop="is_show">
						<el-switch v-model="recruitAddForm.is_show" active-color="#13ce66">
						</el-switch>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisibleAdd = false">返 回</el-button>
				<el-button type="primary" @click="caseSaveAdd('recruitAddForm')">保 存</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	// require('../../../assets/public/quill-import.js') 
	import {
		toolbarOptions,
		quillEditor
	} from '../../../assets/public/quill-import.js'
	export default {
		name: "questionManage",
		components: {
			quillEditor
		},
		data() {
			return {
				tableData: [],
				loading: false,
				height: 0,
				product_page_count: 0, //总页数
				product_row_count: 0, //总条数
				product_page: 1, //当前
				pageSize: 15,
				physicianSelection: null,
				dialogVisibleAdd: false, //添加弹框
				dialogVisibleEdit: false, //修改弹框
				keyword: "",
				category_id: "",

				recruitAddForm: {
					category_id: "",
					name: "",
					workplace: "",
					department_id: "",
					recruit_num: 1,
					duty: "",
					demand: "",
					email: "",
					rank: "",
					page_view: "",
					is_quick: "",
					is_deliver: "",
					is_show: "",
					create_time: "",
				},
				recruitAddSave: {},
				recruitAddFormRules: {
					// title: [{
					// 	required: true,
					// 	message: '标题不能为空',
					// 	trigger: 'blur'
					// }],
					// description: [{
					// 	required: true,
					// 	message: '描述不能为空',
					// 	trigger: 'blur'
					// }],
					// image: [{
					// 	required: true,
					// 	message: '产品图片不能为空',
					// 	trigger: 'blur'
					// }],
					// link_address: [{
					// 	required: true,
					// 	message: '链接不能为空',
					// 	trigger: 'blur'
					// }],
					// rank: [{
					// 	required: true,
					// 	message: '排序不能为空',
					// 	trigger: 'blur'
					// }],
				},
				recruitmentOptions: [],
				recruitmentAddOptions: [],
				categoryAddOptions: [],
				cityOptions: [],
				addIsClick: false,
				questionTypeValue: '',
				mergingRows: null,
				mergingPos: null,
				imageUrl: "",
				editorOption: {
					scrollingContainer: '#editorcontainer',
					placeholder: '',
					// or 'bubble'
					theme: 'snow',
					modules: {
						imageDrop: true,
						ImageExtend: {
							loading: true,
							name: 'img_file',
							action: process.env.VUE_APP_BASE_API + "extends/upload_file/news/", //服务器地址
							change: (xhr, formData) => {}, // 
							response: (res) => {
								return res.data.file_path
							}
						},
						imageResize: {
							displayStyles: {
								backgroundColor: 'black',
								border: 'none',
								color: 'white'
							},
							modules: ['Resize', 'DisplaySize', 'Toolbar'],

						},

						toolbar: {
							container: toolbarOptions,
							handlers: {
								'image': function() {
									QuillWatch.emit(this.quill.id)
								},
								lineheight: function(value) {

									if (value) {
										console.log(this.quill)
										this.quill.format('lineHeight', value);
									} else {

									}
								},

							}
						},

					}

				},

			}
		},
		mounted() {
			this.$nextTick(() => {
				let componyBannerHeight = document.getElementsByClassName("componyBanner-bottom-table")[0]
					.offsetHeight;
				this.height = componyBannerHeight;
			})
			this.recruitmentDepartmentMain()
			this.recruitmentCategoryMain()
			this.cityCategoryMain()
			this.productMain(this.product_page)
		},
		methods: {
			productMain(page) {
				this.loading = true
				this.POST(`supervisor/recruitmentsList/${page}/`, {
					keyword: this.keyword,
					category_id: this.category_id,
					page_num: this.pageSize,
				}).then((res) => {
					if (res.data.code == 200) {
						this.tableData = res.data.data.recruitments_list;
						this.product_page_count = res.data.data.page_count
						this.product_row_count = res.data.data.recruitments_count
						this.product_page = res.data.data.current_page
						this.loading = false
					} else {
						this.tableData = []
						this.$message.error(res.data.message);
						this.loading = false

					}
				}).catch(err => {

					this.loading = false

				});
			},
			// 部门搜索
			recruitmentDepartmentMain() {
				this.GET('supervisor/recruitDepartment/').then((res) => {
					if (res.data.code == 200) {
						this.recruitmentOptions = []
						this.recruitmentAddOptions = []
						this.recruitmentOptions.push({
							label: "全部分类",
							value: ""
						})
						res.data.data.department_list.forEach((val, index) => {
							if (index == 0) {
								this.recruitAddForm.department_id = val.id
							}
							this.recruitmentOptions.push({
								label: val.department,
								value: val.id
							})
							this.recruitmentAddOptions.push({
								label: val.department,
								value: val.id
							})
						})

					}
				})
			},
			// 分类
			recruitmentCategoryMain() {
				this.GET('supervisor/recruitCategory/').then((res) => {
					if (res.data.code == 200) {
						this.categoryAddOptions = []
						res.data.data.category_list.forEach((val, index) => {
							if (index == 0) {
								this.recruitAddForm.category_id = val.id
							}
							this.categoryAddOptions.push({
								label: val.name,
								value: val.id
							})
						})

					}
				})
			},

			// 城市
			cityCategoryMain() {
				this.GET('supervisor/provinceInfo/').then((res) => {
					if (res.data.code == 200) {
						this.cityOptions = []
						res.data.data.province_list.forEach((val, index) => {
							this.cityOptions.push({
								label: val.name,
								value: val.id,
								children: []
							})
							this.GET(`supervisor/cityInfo/${val.id}/`).then((res) => {
								res.data.data.city_list.forEach((v, i) => {
									this.cityOptions[index]['children'].push({
										label: v.name,
										value: v.id,
									})
								})

							})
						})

					}
				})
			},
			handleChange(val) {
				
			},
			// 分类选择
			categoryChange(id) {
				this.category_id = id
				this.productMain(this.product_page)
			},
			// 关键字显示
			keywordChage(val) {
				this.productMain(this.product_page)
			},
			// 上一页
			physicianPrevMain() {

				if (this.product_page > 1) {
					this.product_page--;
					this.productMain(this.product_page)
				}
			},
			// 下一页
			physicianNextMain() {
				if (this.product_page < this.product_page_count) {
					this.product_page++;
					this.productMain(this.product_page)
				}
			},
			// 当前页
			physicianCurrentMain(page) {

				this.product_page = page
				this.productMain(this.product_page)
			},
			// 选择每页多少条
			handleSizeChange(page) {
				this.pageSize = page
				this.productMain(this.product_page)
			},
			// 添加
			caseAddMain() {
				if (!this.addIsClick) {
					this.addIsClick = true
					this.recruitAddSave.department_id = this.recruitAddForm.department_id
					this.recruitAddSave.category_id = this.recruitAddForm.category_id
					this.recruitAddForm = Object.assign({}, this.recruitAddSave)
				}
				this.dialogVisibleAdd = true;
				this.dialogTitle = "添加"
				this.$nextTick(() => {
					addQuillTitle();
				})
				this.$forceUpdate()


			},
			// 编辑
			caseEditMain() {
				if (this.physicianSelection) {
					this.GET('supervisor/alterRecruitments/' + this.physicianSelection.id + '/').then((res) => {
						if (res.data.code == 200) {
							this.dialogVisibleAdd = true;
							if (this.addIsClick) {
								this.addIsClick = false
								this.recruitAddSave = Object.assign({}, this.recruitAddForm)
							}
							res.data.data.department_id = res.data.data.department
							this.recruitAddForm = res.data.data;
							this.recruitAddForm.workplace = this.workplaceMain(this.recruitAddForm.workplace)
							this.dialogTitle = "编辑"
							this.$forceUpdate()
							
						}

					})

				} else {
					this.$message({
						duration: 1500,
						message: "请选择一个需要修改的新闻列表",
						type: 'success',
					});
				}
			},

			workplaceMain(item) {
				
				let currentIndex = 0
				let workplace = []
				let children = null
				for(let i=0;i<item.length;i++){
					for(let j=0;j<this.cityOptions.length;j++){
						children = this.cityOptions[j].children
						for(let k=0;k<children.length;k++){
							if (item[i].id == children[k].value) {
								workplace[currentIndex] = [this.cityOptions[j].value, item[i].id]
								currentIndex++
								
							}
								
						}
						
					}
					if(i == item.length - 1){
						
						return workplace
					}
				}
			},
			// 多选变单选
			handleSelectionChange(row, index) {
				this.physicianSelection = row[0];
				this.tableData.forEach((item) => {
					if (row.length !== 0) {
						if (item.id !== row[row.length - 1].id) {
							this.$refs.multipleTable.toggleRowSelection(item, false)
						}
					}
				})
				
			},
			// 添加
			caseSaveAdd(FromName) {

				// this.$refs[FromName].validate((valid) => {
				// 	if (valid) {
				this.recruitAddForm.demand = document.getElementsByClassName("ql-editor")[1].innerHTML
				
				let workplace = []
				if (this.recruitAddForm.workplace[0] instanceof Array) {
					this.recruitAddForm.workplace.forEach((val, index) => {
						workplace.push(val[1])
					})
				} 
				
				workplace = workplace.toString()

				// return
				if (this.dialogTitle == "添加") {
					this.POST('supervisor/addRecruitments/', {
						category_id: this.recruitAddForm.category_id,
						name: this.recruitAddForm.name,
						workplace: workplace,
						department_id: this.recruitAddForm.department_id,
						recruit_num: this.recruitAddForm.recruit_num,
						demand: this.recruitAddForm.demand,
						email: this.recruitAddForm.email,
						rank: this.recruitAddForm.rank,
						page_view: this.recruitAddForm.page_view,
						is_quick: this.recruitAddForm.is_quick,
						is_deliver: this.recruitAddForm.is_deliver ? 1 : 0,
						is_show: this.recruitAddForm.is_show ? 1 : 0,
						create_time: this.$moment(this.recruitAddForm.create_time).format('YYYY-MM-DD'),
						duty: "1",
						is_quick: '1'
					}).then((res) => {
						if (res.data.code == 200) {
							this.productMain(this.product_page)
							this.$refs[FromName].resetFields();
							this.dialogVisibleAdd = false;
							this.$message({
								duration: 1500,
								message: res.data.message,
								type: 'success',
							});

						} else {
							this.$message.error(res.data.message);

						}
					}).catch(err => {


					});
				} else {
					this.POST(`supervisor/alterRecruitments/${this.physicianSelection?.id}/`, {
						category_id: this.recruitAddForm.category_id,
						name: this.recruitAddForm.name,
						workplace: workplace,
						department_id: this.recruitAddForm.department_id,
						recruit_num: this.recruitAddForm.recruit_num,
						demand: this.recruitAddForm.demand,
						email: this.recruitAddForm.email,
						rank: this.recruitAddForm.rank,
						page_view: this.recruitAddForm.page_view,
						is_quick: this.recruitAddForm.is_quick,
						is_deliver: this.recruitAddForm.is_deliver ? 1 : 0,
						is_show: this.recruitAddForm.is_show ? 1 : 0,
						create_time: this.$moment(this.recruitAddForm.create_time).format('YYYY-MM-DD'),
						duty: "1",
						is_quick: '1'
					}).then((res) => {
						if (res.data.code == 200) {
							this.productMain(this.product_page)
							this.$refs[FromName].resetFields();
							this.dialogVisibleAdd = false;
							this.$message({
								duration: 1500,
								message: res.data.message,
								type: 'success',
							});

						} else {
							this.$message.error(res.data.message);

						}
					}).catch(err => {


					});
				}
				// 	} else {
				// 		console.log('error submit!!');
				// 		return false;
				// 	}
				// });

			},



			// 删除
			caseDeleteMain() {
				if (this.physicianSelection) {
					this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.POST('supervisor/recruitmentsDelete/',{
							batch_id:this.physicianSelection.id
						}).then((res) => {
							if (res.data.code == 200) {
								this.productMain(this.product_page)
								this.$message({
									duration: 1500,
									message: "删除成功",
									type: 'success',
								});
							} else {
								this.$message.error(res.data.message);

							}
						}).catch(err => {


						});
					}).catch(() => {

					});

				} else {
					this.$message({
						duration: 1500,
						message: '请选择需要删除的招聘列表！',
						type: 'warning',
					});
				}
			},
			onChangeAdd(file) {
				let form = new FormData();
				form.append("img_file", file.raw)
				this.FILEPOST('extends/upload_file/banner/', form).then(res => {
					if (res.data.code == 200) {
						this.componyBannerAddForm.image = res.data.data.file_path;
						this.componyBannerAddForm.image_name = res.data.data.file_name;
					}
				})
			},
			httpRequestAdd() {

			},
			beforeAvatarUpload(file) {
				
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				if (!isJPG && !isPNG) {
					this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
				}
				return isJPG;
			}
		}
	}
</script>

<style lang="scss" scoped="">
	.componyBanner {
		width: 100%;
		height: 100%;

		.componyBanner-top {
			width: 100%;
			height: 60px;
			border-bottom: 1px solid #eee;
			padding: 14px 20px;
			box-sizing: border-box;
			display: flex;

		}

		.componyBanner-top .el-input {
			min-width: 120px;
			width: 15%;
			margin-right: 10px;
		}

		.componyBanner-top .el-select {
			min-width: 120px;
			width: 15%;
			margin-right: 10px;
		}

		.componyBanner-bottom {
			width: 100%;
			height: calc(100% - 60px);
			border-bottom: 1px solid #eee;
			box-sizing: border-box;
			position: relative;

			.componyBanner-bottom-table {
				height: calc(100% - 60px);
				width: 100%;
				border-bottom: 1px solid #eee;
			}

			.componyBanner-bottom-page {
				height: 60px;
				width: 100%;
				position: absolute;
				bottom: 0;
				padding: 16px 20px;
				box-sizing: border-box;

				.componyBanner-bottom-page-left {
					float: left;
					line-height: 28px;
				}

				.componyBanner-bottom-page-right {
					float: right;
				}
			}
		}

		.avatar-uploader .el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		.avatar-uploader .el-upload:hover {
			border-color: #409EFF;
		}

		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 200px;
			height: 100px;
			line-height: 100px;
			text-align: center;
			border: 1px solid #eee;
			border-radius: 5px;
		}

		.avatar {
			width: 178px;
			height: 178px;
			display: block;
		}

	}

	/deep/.ql-editor {
		height: 100% !important;

		.ql-container {
			height: 500px !important;
		}

		.ql-editor {
			height: 100% !important;
		}
	}
</style>
